module.exports = __webpack_public_path__ + "media/images/instagram-f0b3dd6865ee717f842166da6e6a34ec.jpg";